var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.65 31.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #828282;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.05,0h-14.46C3.86,0,0,3.86,0,8.6v14.46c0,4.74,3.86,8.6,8.6,8.6h14.46c4.74,0,8.6-3.86,8.6-8.6v-14.46c0-4.74-3.86-8.6-8.6-8.6ZM30.7,23.05c0,4.22-3.43,7.65-7.65,7.65h-14.46c-4.22,0-7.65-3.43-7.65-7.65v-14.46C.95,4.38,4.38.95,8.6.95h14.46c4.22,0,7.65,3.43,7.65,7.65v14.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.83,5.97c-5.43,0-9.85,4.42-9.85,9.85s4.42,9.85,9.85,9.85,9.85-4.42,9.85-9.85-4.42-9.85-9.85-9.85ZM16.3,24.72v-1.66c0-.26-.21-.47-.47-.47s-.47.21-.47.47v1.66c-4.53-.24-8.18-3.88-8.42-8.42h1.66c.26,0,.47-.21.47-.47s-.21-.47-.47-.47h-1.66c.24-4.53,3.88-8.18,8.42-8.42v1.66c0,.26.21.47.47.47s.47-.21.47-.47v-1.66c4.53.24,8.18,3.88,8.42,8.42h-1.66c-.26,0-.47.21-.47.47s.21.47.47.47h1.66c-.24,4.53-3.88,8.18-8.42,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.36,16.9c.21-.31.34-.68.34-1.08,0-.87-.6-1.6-1.4-1.81v-2.21c0-.26-.21-.47-.47-.47s-.47.21-.47.47v2.21c-.81.21-1.4.94-1.4,1.81,0,1.03.84,1.88,1.88,1.88.29,0,.57-.07.81-.19l2.87,3.39c.17.2.47.22.67.06.2-.17.22-.47.06-.67l-2.87-3.39ZM14.9,15.83c0-.51.42-.93.93-.93,0,0,0,0,0,0s0,0,0,0c.51,0,.93.42.93.93s-.42.93-.93.93-.93-.42-.93-.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryGrey);
export default __webpack_public_path__ + "static/media/history-grey.a25d60633583a744af530b641cf8dbc3.svg";
export { ForwardRef as ReactComponent };